import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#unique_course",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Unique Course Details")
  ])
], -1)
const _hoisted_3 = {
  id: "unique_course",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3 mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_13 = {
  key: 1,
  disabled: "",
  type: "button",
  class: "btn btn-success mt-6 p-3",
  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "d-flex pt-4 pb-2"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-4 text-gray-600" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mt-2" })
    ])
  ])
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" })
], -1)
const _hoisted_19 = { class: "card mb-5 mb-xl-10" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#unique_course_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control ps-10 w-200px mt-1 form-control-sm",
          style: {"height":"1em"},
          placeholder: "Search"
        })
      ])
    ])
  ])
], -1)
const _hoisted_21 = {
  id: "unique_course_data",
  class: "collapse show"
}
const _hoisted_22 = { class: "collapse show" }
const _hoisted_23 = { class: "card-body border-top p-6" }
const _hoisted_24 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_25 = {
  key: 0,
  class: "commaSeparator"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Form = _resolveComponent("Form")!
  const _component_UniqueCourseDrawer = _resolveComponent("UniqueCourseDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Form, {
      onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.formSubmit())),
      class: "form",
      "validation-schema": _ctx.AssociationSchema
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _hoisted_10,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Tranche",
                        modelValue: _ctx.selectedTranche,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTranche) = $event)),
                        style: {"width":"100%"},
                        onChange: _ctx.btnCheckStatus
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranche, (trans) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: trans.id,
                              label: trans.label,
                              value: trans.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(trans.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      (_ctx.btnCheck)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.courseInfoUnique())),
                            type: "button",
                            class: "btn btn-success mt-6 p-3",
                            style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                          }, [
                            _createTextVNode(" Search "),
                            _hoisted_12
                          ]))
                        : (_openBlock(), _createElementBlock("button", _hoisted_13, [
                            _createTextVNode(" Search "),
                            _hoisted_14
                          ]))
                    ])
                  ]),
                  (_ctx.showCourseNotice == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                    : _createCommentVNode("", true),
                  (_ctx.showCourseNotice == true)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                        _hoisted_18,
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                  _createVNode(_component_Datatable, {
                                    "table-data": _ctx.uniqueCourseList,
                                    "table-header": _ctx.tableHeader,
                                    "enable-items-per-page-dropdown": true
                                  }, {
                                    "cell-unique_course": _withCtx(({ row: uniqueCourse }) => [
                                      _createTextVNode(_toDisplayString(uniqueCourse?.course_alias?.name), 1)
                                    ]),
                                    "cell-code": _withCtx(({ row: uniqueCourse }) => [
                                      _createTextVNode(_toDisplayString(uniqueCourse?.course_alias?.code), 1)
                                    ]),
                                    "cell-association": _withCtx(({ row: uniqueCourse }) => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueCourse?.entity, (item, index) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                          (item?.active_status == 1)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(item?.entity_short_name), 1))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128))
                                    ]),
                                    "cell-course": _withCtx(({ row: uniqueCourse }) => [
                                      _createTextVNode(_toDisplayString(uniqueCourse?.course_count), 1)
                                    ]),
                                    "cell-actions": _withCtx(({ row: uniqueCourse }) => [
                                      _createElementVNode("button", {
                                        title: "View Courses",
                                        onClick: ($event: any) => (_ctx.view(uniqueCourse?.course_info)),
                                        "data-kt-drawer-toggle": "true",
                                        "data-kt-drawer-target": "#kt_drawer_unique_course",
                                        id: "kt_drawer_unique_course_button",
                                        class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                      }, _hoisted_28, 8, _hoisted_26)
                                    ]),
                                    _: 1
                                  }, 8, ["table-data", "table-header"])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])), [
                        [_directive_loading, _ctx.load]
                      ])
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _createVNode(_component_UniqueCourseDrawer)
  ], 64))
}